module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.offers && _vm.offers.length > 0) ? _c('div', {
    staticClass: "section-card"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('div', {
    staticClass: "icon-wrap"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "9",
      "cy": "7",
      "r": "4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M23 21v-2a4 4 0 00-3-3.87"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16 3.13a4 4 0 010 7.75"
    }
  })])]), _vm._v("\n      Current Offers on This ASIN\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "section-actions"
  }, [_c('button', {
    staticClass: "btn-secondary"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "7 10 12 15 17 10"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "15",
      "x2": "12",
      "y2": "3"
    }
  })]), _vm._v("\n        Export CSV\n      ")])])]), _vm._v(" "), _c('table', {
    staticClass: "data-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.offers), function(offer, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('div', {
      staticClass: "seller-cell"
    }, [(offer.hasBuyBox) ? _c('span', {
      staticClass: "seller-badge winner"
    }, [_vm._v("Winner")]) : _vm._e(), _vm._v(" "), (offer.isMyOffer) ? _c('span', {
      staticClass: "seller-badge you"
    }, [_vm._v("You")]) : _vm._e(), _vm._v(" "), (_vm.sellerStorefrontUrl(offer.sellerId)) ? _c('a', {
      staticClass: "seller-id seller-id-link",
      attrs: {
        "href": _vm.sellerStorefrontUrl(offer.sellerId),
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_vm._v(_vm._s(offer.sellerId))]) : _c('span', {
      staticClass: "seller-id"
    }, [_vm._v(_vm._s(offer.sellerId))])])]), _vm._v(" "), _c('td', {
      staticClass: "align-right price-cell",
      class: {
        winner: offer.hasBuyBox,
        you: offer.isMyOffer
      }
    }, [_vm._v("\n          " + _vm._s(_vm.currencySymbol) + _vm._s(offer.price.toFixed(2)) + "\n        ")]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "fulfillment-badge",
      class: offer.fulfillment.toLowerCase()
    }, [_vm._v("\n            " + _vm._s(offer.fulfillment) + "\n          ")])]), _vm._v(" "), _c('td', {
      staticClass: "feedback-cell"
    }, [(offer.sellerPositiveFeedbackRating != null) ? [_c('span', {
      staticClass: "feedback-pct"
    }, [_vm._v(_vm._s(offer.sellerPositiveFeedbackRating) + "%")]), _vm._v(" "), _c('span', {
      staticClass: "feedback-count"
    }, [_vm._v(" positive · " + _vm._s(_vm.formatFeedbackCount(offer.sellerFeedbackCount)) + " ratings")])] : _c('span', {
      staticClass: "feedback-count"
    }, [_vm._v("—")])], 2), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "status-text",
      class: _vm.statusClass(offer)
    }, [_vm._v("\n            " + _vm._s(offer.status) + "\n          ")])])])
  }), 0)])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Seller")]), _vm._v(" "), _c('th', {
    staticClass: "align-right"
  }, [_vm._v("Price")]), _vm._v(" "), _c('th', [_vm._v("Fulfillment")]), _vm._v(" "), _c('th', [_vm._v("Seller Rating")]), _vm._v(" "), _c('th', [_vm._v("Status")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3db240f4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product-details/CurrentOffers.vue
// module id = 758
// module chunks = 2